// Native Shopify consent handoff. Verify checkout/order behavior before enabling Flow.
// Uses the existing CookieYes -> Shopify Customer Privacy integration.
// Stores only the current choice in a private Shopify cart/order attribute.
// No external service, additional banner, API key or customer identity required.
(() => {
  if (window.TrackershopOpenAIConsent) return;
  const attribute = '__openai_ads_consent';
  let pending = Promise.resolve();
  let lastSaved = '';

  function snapshot() {
    const privacy = window.Shopify?.customerPrivacy;
    const choice = {
      version: 1,
      source: 'shopify_customer_privacy',
      analyticsProcessingAllowed: privacy?.analyticsProcessingAllowed?.() === true,
      marketingAllowed: privacy?.marketingAllowed?.() === true,
      collectedAt: new Date().toISOString(),
      expiresAt: new Date(Date.now() + 24 * 60 * 60 * 1000).toISOString(),
    };
    // Retain the original ad click value only while both purposes are allowed.
    const storageKey = 'trackershop_openai_oppref';
    if (choice.analyticsProcessingAllowed && choice.marketingAllowed) {
      const landing = new URL(window.location.href).searchParams.get('oppref');
      let previous;
      try { previous = window.sessionStorage.getItem(storageKey); } catch {}
      const oppref = landing || previous;
      if (typeof oppref === 'string' && oppref.length && oppref.length <= 4096) {
        choice.oppref = oppref;
        try { window.sessionStorage.setItem(storageKey, oppref); } catch {}
      }
    } else {
      try { window.sessionStorage.removeItem(storageKey); } catch {}
    }
    return choice;
  }

  function sync() {
    // Serialize writes so a slower earlier grant cannot overwrite a withdrawal.
    // Read the current choice at execution time rather than queuing stale choices.
    pending = pending.catch(() => {}).then(async () => {
      const choice = snapshot();
      const state = JSON.stringify([choice.analyticsProcessingAllowed, choice.marketingAllowed, choice.oppref]);
      if (state === lastSaved) return;
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/update.js`, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { [attribute]: JSON.stringify(choice) } }),
      });
      if (!response.ok) throw new Error(`Consent cart update failed (${response.status})`);
      lastSaved = state;
    });
    return pending;
  }

  window.TrackershopOpenAIConsent = { sync };
  const update = () => { sync().catch(() => { /* Retry on the next change or page load. */ }); };
  document.addEventListener('visitorConsentCollected', update);
  window.addEventListener('pageshow', update);
  update(); // Unknown consent overwrites any previous cart grant with denial.
  if (!window.Shopify?.customerPrivacy && window.Shopify?.loadFeatures) {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], error => {
      if (!error) update();
    });
  }
})();
